import { getHierarchy } from 'services/axios/hierarchy'

export const actions = {
  GET_MODULES_HIERARCHY: 'GET_MODULES_HIERARCHY',
  HANDLE_PAGINATION: 'HANDLE_PAGINATION',
}

// Action creators
export const getHierarchyInfoForModules = ({ skip, limit }) => {
  return async (dispatch) => {
    const response = await getHierarchy(skip, limit)
    if (response?.status === 200 && response?.data?.message === 'success') {
      dispatch({
        type: actions.GET_MODULES_HIERARCHY,
        payload: {
          modulesHierarchyList: response?.data?.data?.modulesHierarchyList,
          totalCount: response?.data?.data?.totalCount,
        },
      })
    }
  }
}

export const handlePagination = (pagination) => {
  return {
    type: actions.HANDLE_PAGINATION,
    payload: pagination,
  }
}
